/**
 * Token values that exist in the CSS; these are a bridge
 * to the tokens used in Animations.less.
 */

/**
 * Standardised animation duration timings;
 * these are all expressed in milliseconds,
 * and match those in Animations.less
 */
const AnimationDuration = {
  Short: 150,
  Medium: 200,
  Long: 400,
};

export { AnimationDuration };
